import React from 'react'
import '../home.scss'
import Recipe from '../Pages/GetRecipe'
type Props={
    recipe:Recipe[],
    setShow:React.Dispatch<React.SetStateAction<boolean>>
}
const ModalElement = (props:Props) =>{
    const recipeBoxClass = 'box fadeUp bg-red-200 text-xs rounded-lg m-4 py-4 px-4'
    let indexnum = 0
    const indexNumber = ()=>{
        indexnum+=1
        return indexnum
    }
    return(
        <div id="overlay">
            <div className=''>
                <a type='button' className='absolute top-36 left-4 text-5xl text-white' onClick={()=>props.setShow(false)}>×</a>
                <ul className='grid grid-cols-3 grid-rows-2'>
                {props.recipe.map((recipe,index) => (
                    <div key ={index} className={'box fadeUp bg-red-200 text-xs rounded-lg m-4 py-4 px-4 delay-time0' + indexNumber()}>
                        <img src={recipe.recipe_thumbnail}/>
                        <a className=' border-b-2 border-cyan-800 text-cyan-800' href={recipe.recipe_url}>{recipe.title}</a>
                    </div>
                ))}
            </ul>
            </div>

        </div>
    )

}
export default ModalElement